import { Component } from '@angular/core';
import { TableModule } from 'primeng/table';
import { PaTableComponent } from '../../../../shared/ui-kit/pa-table/pa-table.component';
import {
  PaTableColumn,
  PaTableData,
  PaTableAction,
  PaTableColumnType,
  PaTableGroupConfig,
  PaTableGroupMeta,
} from '../../../../shared/ui-kit/pa-table/models/pa-table.model';
import { NgIf } from '@angular/common';
import { MetaPagination } from 'src/app/core/models/meta.interface';
import { FileFromServer } from 'src/app/core/models/files';

const MONEY_PAY_METHODS: Array<{ id: number; name: string }> = [
  { id: 0, name: 'Другое' },
  { id: 1, name: 'Банковский перевод' },
  { id: 2, name: 'Банковская карта' },
  { id: 3, name: 'Зарплатный проект' },
  { id: 4, name: 'Наличные' },
  { id: 5, name: 'Перевод на карту' },
  { id: 6, name: 'Платёжная система' },
  { id: 7, name: 'СБП' },
  { id: 9, name: 'Нет' },
];
import { FilterBarComponent } from 'src/app/shared/components/filter-bar/filter-bar.component';
import { ApiService } from 'src/app/core/services/api.service';
import {
  FilterResult,
  FiltersConfig,
  FilterTypes,
  GroupOption,
} from 'src/app/shared/models/filter.interface';
import { FiltersModalService } from 'src/app/core/services/filters-modal.service';

@Component({
  selector: 'app-table-view',
  templateUrl: './table-view.component.html',
  styleUrls: ['./table-view.component.scss'],
  imports: [
    TableModule,
    NgIf,
    FilterBarComponent,
    PaTableComponent,
  ],
  standalone: true,
})
export class TableViewComponent {
  private readonly groupingOptions: GroupOption[] = [
    { id: 'category', name: 'Категория', key: 'category' },
    { id: 'inventoryStatus', name: 'Статус наличия', key: 'inventoryStatus' },
  ];

  filterData: FilterResult = {
    filters: {},
    count: 0,
  };

  pagination: MetaPagination = {
    total_count: 0,
    page: 0,
    per_page: 30,
  };

  products: PaTableData[] = [
    {
      id: '1000',
      code: 'f230fh0g3',
      name: 'Bamboo Watch',
      description: 'Product Description',
      image: 'bamboo-watch.jpg',
      price: 65,
      category: 'Accessories',
      quantity: 24,
      inventoryStatus: 'INSTOCK',
      rating: 5,
      createdAt: new Date('2024-01-15'),
      isActive: true,
    },
    {
      id: '1001',
      code: 'f230fh0g4',
      name: 'Black Watch',
      description: 'Product Description',
      image: 'black-watch.jpg',
      price: 72,
      category: 'Accessories',
      quantity: 61,
      inventoryStatus: 'INSTOCK',
      rating: 4,
      createdAt: new Date('2024-01-20'),
      isActive: true,
    },
    {
      id: '1002',
      code: 'f230fh0g5',
      name: 'Blue Band',
      description: 'Product Description',
      image: 'blue-band.jpg',
      price: 79,
      category: 'Fitness',
      quantity: 2,
      inventoryStatus: 'LOWSTOCK',
      rating: 3,
      createdAt: new Date('2024-01-25'),
      isActive: false,
    },
    {
      id: '1003',
      code: 'f230fh0g6',
      name: 'Blue T-Shirt',
      description: 'Product Description',
      image: 'blue-t-shirt.jpg',
      price: 29,
      category: 'Clothing',
      quantity: 25,
      inventoryStatus: 'INSTOCK',
      rating: 5,
      createdAt: new Date('2024-01-30'),
      isActive: true,
    },
  ];

  columns: PaTableColumn[] = [
    { field: 'id', header: 'ID', width: '80px' },
    { field: 'code', header: 'Код', width: '120px' },
    { field: 'name', header: 'Название', width: '200px' },
    { field: 'category', header: 'Категория', width: '150px' },
    { field: 'price', header: 'Цена', width: '100px', type: PaTableColumnType.Number },
    { field: 'quantity', header: 'Количество', width: '100px', type: PaTableColumnType.Number },
    { field: 'createdAt', header: 'Дата создания', width: '130px', type: PaTableColumnType.Date },
    { field: 'isActive', header: 'Активен', width: '100px', type: PaTableColumnType.Boolean },
  ];

  // Столбцы с фиксацией
  stickyColumns: PaTableColumn[] = [
    { field: 'id', header: 'ID', width: '80px' },
    { field: 'code', header: 'Код', width: '120px' },
    { field: 'name', header: 'Название', width: '200px' },
    { field: 'category', header: 'Категория', width: '150px' },
    { field: 'price', header: 'Цена', width: '100px', type: PaTableColumnType.Number },
    { field: 'quantity', header: 'Количество', width: '100px', type: PaTableColumnType.Number },
    { field: 'rating', header: 'Рейтинг', width: '100px', type: PaTableColumnType.Number },
    { field: 'inventoryStatus', header: 'Статус', width: '120px' },
    { field: 'createdAt', header: 'Дата создания', width: '130px', type: PaTableColumnType.Date },
    { field: 'isActive', header: 'Активен', width: '100px', type: PaTableColumnType.Boolean },
    { field: 'description', header: 'Описание', width: '250px' },
  ];

  extendedProducts: PaTableData[] = [
    {
      id: '1000',
      code: 'f230fh0g3',
      name: 'Bamboo Watch',
      description: 'Стильные часы из бамбука с современным дизайном',
      image: 'bamboo-watch.jpg',
      price: 65,
      category: 'Accessories',
      quantity: 24,
      inventoryStatus: 'В наличии',
      rating: 5,
      createdAt: new Date('2024-01-15'),
      isActive: true,
    },
    {
      id: '1001',
      code: 'f230fh0g4',
      name: 'Black Watch',
      description: 'Элегантные черные часы для делового стиля',
      image: 'black-watch.jpg',
      price: 72,
      category: 'Accessories',
      quantity: 61,
      inventoryStatus: 'В наличии',
      rating: 4,
      createdAt: new Date('2024-01-20'),
      isActive: true,
    },
    {
      id: '1002',
      code: 'f230fh0g5',
      name: 'Blue Band',
      description: 'Фитнес-браслет с множеством функций',
      image: 'blue-band.jpg',
      price: 79,
      category: 'Fitness',
      quantity: 2,
      inventoryStatus: 'Мало',
      rating: 3,
      createdAt: new Date('2024-01-25'),
      isActive: false,
    },
    {
      id: '1003',
      code: 'f230fh0g6',
      name: 'Blue T-Shirt',
      description: 'Комфортная футболка из натурального хлопка',
      image: 'blue-t-shirt.jpg',
      price: 29,
      category: 'Clothing',
      quantity: 25,
      inventoryStatus: 'В наличии',
      rating: 5,
      createdAt: new Date('2024-01-30'),
      isActive: true,
    },
    {
      id: '1004',
      code: 'f230fh0g7',
      name: 'Gaming Headset',
      description: 'Профессиональные наушники для геймеров',
      image: 'gaming-headset.jpg',
      price: 99,
      category: 'Electronics',
      quantity: 15,
      inventoryStatus: 'В наличии',
      rating: 4,
      createdAt: new Date('2024-02-01'),
      isActive: true,
    },
    {
      id: '1005',
      code: 'f230fh0g8',
      name: 'Wireless Mouse',
      description: 'Беспроводная мышь с высокой точностью',
      image: 'wireless-mouse.jpg',
      price: 45,
      category: 'Electronics',
      quantity: 8,
      inventoryStatus: 'Мало',
      rating: 4,
      createdAt: new Date('2024-02-05'),
      isActive: true,
    },
  ];

  tableActions: PaTableAction[] = [
    {
      id: 'custom',
      label: 'Просмотр',
      icon: 'pi pi-eye',
      command: (item: PaTableData) => {
        console.log('Просмотр элемента:', item);
      },
    },
    {
      id: 'edit',
      label: 'Редактировать',
      icon: 'pi pi-pencil',
      command: (item: PaTableData) => {
        console.log('Редактирование элемента:', item);
      },
    },
    {
      id: 'custom',
      label: 'Дублировать',
      icon: 'pi pi-copy',
      command: (item: PaTableData) => {
        console.log('Дублирование элемента:', item);
      },
      visible: (item: PaTableData) => item.isActive === true,
    },
    {
      id: 'delete',
      label: 'Удалить',
      icon: 'pi pi-trash',
      command: (item: PaTableData) => {
        console.log('Удаление элемента:', item);
      },
    },
  ];

  selectedSize = 'p-datatable-lg';
  isLoading = false;
  selectedItems: PaTableData[] = [];

  /**
   * Столбцы для группировки
   */
  groupedColumns: PaTableColumn[] = [
    {
      field: 'employee',
      header: 'Сотрудник',
      width: '240px',
      visibleOnMobile: true,
    },
    {
      field: 'amount',
      header: 'Сумма',
      width: '220px',
      type: PaTableColumnType.Currency,
      visibleOnMobile: true,
    },
    {
      field: 'salary_period',
      header: 'Зарплатный период',
      width: '220px',
      visibleOnMobile: true,
    },
    {
      field: 'date_of_payment',
      header: 'Дата начисления',
      width: '200px',
      type: PaTableColumnType.Date,
      visibleOnMobile: true,
    },
    {
      field: 'date_of_payment_execution',
      header: 'Дата выплаты',
      width: '150px',
      type: PaTableColumnType.Date,
      visibleOnMobile: true,
    },
  ];

  /**
   * Данные для группировки
   */
  groupedProducts: PaTableData[] = [
    {
      employee: 'Пётр Иванов',
      pays_method: 4,
      amount: 10000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-16',
      date_of_payment_execution: '2026-09-22',
    },
    {
      employee: 'Анна Смирнова',
      pays_method: 4,
      amount: 5000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-16',
      date_of_payment_execution: '2026-09-22',
    },
    {
      employee: 'Иван Петров',
      pays_method: 1,
      amount: 5000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-20',
      date_of_payment_execution: '2026-09-26',
    },
    {
      employee: 'Сергей Волков',
      pays_method: 9,
      amount: 10000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-25',
      date_of_payment_execution: '2026-09-30',
    },
    {
      employee: 'Екатерина Соколова',
      pays_method: 9,
      amount: 9000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-28',
      date_of_payment_execution: '2026-10-02',
    },
    {
      employee: 'Мария Кузнецова',
      pays_method: 9,
      amount: 3000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-22',
      date_of_payment_execution: '2026-09-28',
    },
    {
      employee: 'Александр Сидоров',
      pays_method: 7,
      amount: 10000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-28',
      date_of_payment_execution: '2026-10-02',
    },
    {
      employee: 'Дмитрий Петров',
      pays_method: 7,
      amount: 10000,
      salary_period: '01.09–15.09.26',
      date_of_payment: '2026-09-28',
      date_of_payment_execution: '2026-10-02',
    },
  ];

  /**
   * Конфигурация группировки по способам выплаты.
   * meta строится на основе моковых данных groupedProducts:
   * - name: название способа выплаты из MONEY_PAY_METHODS
   * - description: "Общая сумма ХХХ ₽, N выплат"
   */
  get groupByPaysMethod(): PaTableGroupConfig {
    const totals: Record<
      string,
      {
        sum: number;
        count: number;
      }
    > = {};

    for (const row of this.groupedProducts) {
      const key = String(row.pays_method);
      if (!totals[key]) {
        totals[key] = {
          sum: 0,
          count: 0,
        };
      }
      totals[key].sum += Number(row.amount) || 0;
      totals[key].count += 1;
    }

    const meta = MONEY_PAY_METHODS.reduce(
      (acc, item) => {
        const key = String(item.id);
        const stat = totals[key];

        let description: string | undefined;
        if (stat) {
          const formattedSum = stat.sum.toLocaleString('ru-RU');
          const countLabel =
            stat.count === 1 ? 'платёж' : 'платёжей';
          description = `Общая сумма ${formattedSum} ₽ · ${stat.count} ${countLabel}`;
        }

        acc[key] = {
          name: item.name,
          description,
        } as PaTableGroupMeta;

        return acc;
      },
      {} as Record<string, PaTableGroupMeta>,
    );

    return {
      field: 'pays_method',
      meta,
    };
  }

  constructor(
    private readonly filtersModalService: FiltersModalService,
    private readonly api: ApiService,
  ) {}

  toggleLoading(): void {
    this.isLoading = !this.isLoading;
  }

  onSelectionChange(selectedItems: PaTableData[]): void {
    this.selectedItems = selectedItems;
  }

  clearSelection(): void {
    this.selectedItems = [];
  }

  onActionClick(event: { action: PaTableAction; item: PaTableData }): void {
    console.log('Действие:', event.action.label, 'для элемента:', event.item);
  }

  openFilterPanel(): void {
    const filtersConfig: FiltersConfig = {
      title: 'Фильтры',
      grouping: {
        fields: [
          {
            key: 'group_by',
            label: 'Группировка',
            options: this.groupingOptions,
          },
        ],
        required: false,
      },
      filters: [
        {
          dataKey: 'category',
          filterType: FilterTypes.Select,
          label: 'Категория',
          placeholder: 'Выберите категорию...',
          selectOptions: [
            { id: 'Accessories', name: 'Accessories' },
            { id: 'Fitness', name: 'Fitness' },
            { id: 'Clothing', name: 'Clothing' },
            { id: 'Electronics', name: 'Electronics' },
          ],
        },
      ],
      savedFilters: this.filterData.filters,
      defaultFilters: {},
      onReset: () => {
        this.filterData = { filters: {}, count: 0 };
      },
    };

    this.filtersModalService.openFilter(filtersConfig).subscribe((result) => {
      if (result?.role === 'saved' && result.data) {
        this.filterData = result.data;
        this.api.toastPresent('Настройки применены');
      }
    });
  }

  // Моковые данные для демонстрации времени с видеоархивом
  timeData: PaTableData[] = [
    {
      id: '1',
      name: 'ПВЗ №1 - Полный набор с камерами',
      pvzId: 101,
      timestamp: 1704067200,
      timeStart: 32400, // 9:00
      timeEnd: 75600, // 21:00
      hours: 12,
      hasCameras: true,
    },
    {
      id: '2',
      name: 'ПВЗ №2 - Полный набор без камер',
      pvzId: 102,
      timestamp: 1704067200,
      timeStart: 32400, // 9:00
      timeEnd: 64800, // 18:00
      hours: 9,
      hasCameras: false,
    },
    {
      id: '5',
      name: 'ПВЗ №5 - Только начало, hours есть, камеры есть',
      pvzId: 105,
      timestamp: 1704067200,
      timeStart: 32400, // 9:00
      timeEnd: null,
      hours: 5,
      hasCameras: true,
    },
    {
      id: '6',
      name: 'ПВЗ №6 - Только начало, hours есть, камер нет',
      pvzId: 106,
      timestamp: 1704067200,
      timeStart: 36000, // 10:00
      timeEnd: null,
      hours: 3,
      hasCameras: false,
    },
    // === ПУСТЫЕ СЛУЧАИ ===
    {
      id: '15',
      name: 'ПВЗ №15 - Время null, hours нет, камеры есть',
      pvzId: 115,
      timestamp: 1704067200,
      timeStart: null,
      timeEnd: null,
      hours: null,
      hasCameras: true,
    },
    {
      id: '16',
      name: 'ПВЗ №16 - Время null, hours нет, камер нет',
      pvzId: 116,
      timestamp: 1704067200,
      timeStart: null,
      timeEnd: null,
      hours: null,
      hasCameras: false,
    },
    // === ГРАНИЧНЫЕ СЛУЧАИ ===
    {
      id: '17',
      name: 'ПВЗ №17 - Полночь до конца дня',
      pvzId: 117,
      timestamp: 1704067200,
      timeStart: 0, // 0:00
      timeEnd: 86400, // 24:00
      hours: 24,
      hasCameras: true,
    },
    {
      id: '18',
      name: 'ПВЗ №18 - Нулевой интервал',
      pvzId: 118,
      timestamp: 1704067200,
      timeStart: 32400, // 9:00
      timeEnd: 32400, // 9:00
      hours: 0,
      hasCameras: true,
    },
    {
      id: '19',
      name: 'ПВЗ №19 - Нулевое время работы',
      pvzId: 119,
      timestamp: 1704067200,
      timeStart: 32400, // 9:00
      timeEnd: 32400, // 9:00
      hours: 0,
      hasCameras: false,
    },
    {
      id: '20',
      name: 'ПВЗ №20 - Короткий интервал (1 мин)',
      pvzId: 120,
      timestamp: 1704067200,
      timeStart: 32400, // 9:00
      timeEnd: 32460, // 9:01
      hours: 0,
      hasCameras: true,
    },
  ];

  timeColumns: PaTableColumn[] = [
    { field: 'name', header: 'Название', width: '150px', visibleOnMobile: true },
    { field: 'pvzId', header: 'ID ПВЗ', width: '100px', type: PaTableColumnType.Number },
    {
      field: 'timestamp',
      header: 'Время работы',
      width: '200px',
      type: PaTableColumnType.TimeRange,
      icon: 'pi-clock',
      visibleOnMobile: true,
    },
    { field: 'hours', header: 'Часов', width: '100px', type: PaTableColumnType.Number, icon: 'pi-clock' },
    { field: 'hasCameras', header: 'Есть камеры', width: '120px', type: PaTableColumnType.Boolean, icon: 'pi-camera' },
  ]

  imageTextData: PaTableData[] = [
    {
      id: '1',
      datetime: new Date('2024-01-15T10:30:00'),
      purpose: 'Оплата за услуги консультации',
      contract: 'Договор №12345 от 10.01.2024',
      paymentType: 'Банковский перевод',
      bank: {
        name: 'Сбербанк',
        image: '/assets/icons/favicon-96x96.png',
      },
      status: ['Оплачено'],
    },
    {
      id: '2',
      datetime: new Date('2024-01-16T14:15:00'),
      purpose: 'Возврат средств за неоказанную услугу',
      contract: 'Договор №12346 от 12.01.2024',
      paymentType: 'Банковский перевод',
      bank: {
        name: 'ВТБ',
        image: '/assets/icons/favicon-96x96.png',
      },
      status: ['В обработке'],
    },
    {
      id: '3',
      datetime: new Date('2024-01-17T09:45:00'),
      purpose: 'Оплата аренды офиса',
      contract: 'Договор аренды №789 от 01.01.2024',
      paymentType: 'Электронный платеж',
      bank: {
        name: 'Неизвестный банк',
      },
      status: ['Оплачено'],
    },
    {
      id: '4',
      datetime: new Date('2024-01-18T16:20:00'),
      purpose: 'Поступление оплаты от клиента',
      contract: 'Договор №12347 от 15.01.2024',
      paymentType: 'Банковская карта',
      bank: {
        name: 'Тинькофф',
        image: '/assets/icons/favicon-96x96.png',
      },
      status: ['Подтверждено'],
    },
  ];

  imageTextColumns: PaTableColumn[] = [
    {
      field: 'datetime',
      header: 'Дата время',
      width: '160px',
      type: PaTableColumnType.DateTime,
      visibleOnMobile: true,
      tooltip: 'Дата и время с подсказкой для таблицы',
    },
    {
      field: 'purpose',
      header: 'Назначение',
      width: '250px',
      visibleOnMobile: true,
      tooltip: 'Название ПВЗ с подсказкой для таблицы',
    },
    {
      field: 'contract',
      header: 'Договор',
      width: '200px',
      visibleOnMobile: true,
    },
    {
      field: 'bank',
      header: 'Банк',
      width: '180px',
      type: PaTableColumnType.ImageText,
      visibleOnMobile: true,
    },
    {
      field: 'paymentType',
      header: 'Тип оплаты',
      width: '150px',
      visibleOnMobile: true,
    },

    {
      field: 'status',
      header: 'Статус',
      width: '200px',
      type: PaTableColumnType.Tags,
      visibleOnMobile: true,
    },
  ];

  // Моковые данные для демонстрации due_date с recurrent_period
  dueDateData: PaTableData[] = [
    {
      id: '1',
      name: 'Задача с периодичностью',
      due_date: {
        date: '2025-11-30T00:00:00.000Z',
        recurrent_period: 'WEEK',
      },
      status: 'В работе',
    },
    {
      id: '2',
      name: 'Задача с обычной датой',
      due_date: '2025-12-15T00:00:00.000Z',
      status: 'Запланировано',
    },
    {
      id: '3',
      name: 'Ежедневная задача',
      due_date: {
        date: '2025-12-01T00:00:00.000Z',
        recurrent_period: 'DAY',
      },
      status: 'В работе',
    },
    {
      id: '4',
      name: 'Ежемесячная задача',
      due_date: {
        date: '2025-12-20T00:00:00.000Z',
        recurrent_period: 'MONTH',
      },
      status: 'Запланировано',
    },
  ];

  dueDateColumns: PaTableColumn[] = [
    { field: 'name', header: 'Название', width: '200px', visibleOnMobile: true },
    { field: 'due_date', header: 'Срок', width: '120px', type: PaTableColumnType.Date, icon: 'pi-calendar', visibleOnMobile: true },
    { field: 'status', header: 'Статус', width: '150px', visibleOnMobile: true },
  ];

  private readonly previewIcon = '/assets/icons/web-app-manifest-512x512.png';

  productsWithImages: PaTableData[] = [
    {
      id: 'P-001',
      name: 'Карточка с тремя изображениями',
      category: 'Маркетинг',
      photos: [
        this.previewIcon,
        this.previewIcon,
        this.previewIcon,
      ],
    },
    {
      id: 'P-002',
      name: 'Карточка с большим набором изображений',
      category: 'Товар дня',
      photos: [
        this.previewIcon,
        this.previewIcon,
        this.previewIcon,
        this.previewIcon,
        this.previewIcon,
      ],
    },
    {
      id: 'P-003',
      name: 'Карточка без изображений',
      category: 'Черновики',
      photos: [],
    },
    {
      id: 'P-004',
      name: 'Карточка с файлами разных типов',
      category: 'Документы',
      files: [
        {
          uuid: '1',
          url: '/assets/icons/favicon-96x96.png',
          url_preview: '/assets/icons/favicon-96x96.png',
          original_name: 'document',
          ext: 'pdf',
          type: 'file',
          filesize: 1231233,
          added: '2025-08-21T12:00:00Z',
        } as FileFromServer,
        {
          uuid: '2',
          url: '/assets/icons/favicon-96x96.png',
          url_preview: '/assets/icons/favicon-96x96.png',
          original_name: 'report',
          ext: 'docx',
          type: 'file',
        } as FileFromServer,
        {
          uuid: '3',
          url: this.previewIcon,
          url_preview: this.previewIcon,
          original_name: 'image',
          ext: 'jpg',
          type: 'image',
        } as FileFromServer,
        {
          uuid: '4',
          url: this.previewIcon,
          url_preview: this.previewIcon,
          original_name: 'photo',
          ext: 'png',
          type: 'image',
        } as FileFromServer,
      ],
    },
    {
      id: 'P-005',
      name: 'Карточка с множеством файлов',
      category: 'Архив',
      files: [
        {
          uuid: '1',
          url: this.previewIcon,
          url_preview: this.previewIcon,
          original_name: 'img1',
          ext: 'jpg',
          type: 'image',
        } as FileFromServer,
        {
          uuid: '2',
          url: this.previewIcon,
          url_preview: this.previewIcon,
          original_name: 'img2',
          ext: 'jpg',
          type: 'image',
        } as FileFromServer,
        {
          uuid: '3',
          url: this.previewIcon,
          url_preview: this.previewIcon,
          original_name: 'img3',
          ext: 'jpg',
          type: 'image',
        } as FileFromServer,
        {
          uuid: '4',
          url: '/assets/icons/favicon-96x96.png',
          url_preview: '/assets/icons/favicon-96x96.png',
          original_name: 'file1',
          ext: 'pdf',
          type: 'file',
        } as FileFromServer,
        {
          uuid: '5',
          url: '/assets/icons/favicon-96x96.png',
          url_preview: '/assets/icons/favicon-96x96.png',
          original_name: 'file2',
          ext: 'xlsx',
          type: 'file',
        } as FileFromServer,
      ],
    },
  ];

  columnsWithImages: PaTableColumn[] = [
    { field: 'id', header: 'ID', width: '120px' },
    { field: 'photos', header: 'Изображения', width: '160px', type: PaTableColumnType.Images, visibleOnMobile: true },
    { field: 'files', header: 'Файлы', width: '160px', type: PaTableColumnType.Images, visibleOnMobile: true},
    { field: 'name', header: 'Название', width: '200px', visibleOnMobile: true },
    { field: 'category', header: 'Категория', width: '160px' },
  ];


  /**
   * Моковые данные для демонстрации иконки и текста в ячейках
   */
  iconTextData: PaTableData[] = [
    {
      id: '1',
      employees: 'Иванов И.И.',
      sum: 125000,
      payout: {
        icon: 'pi pi-check-circle',
        severity: 'success',
        text: 'выплачено 22.09.25',
      },
      date: '22.09.25',
      comments: 'Оплата по договору №12 от 10.09.25',
    },
    {
      id: '2',
      employees: 'Петров П.П.',
      sum: 85000,
      payout: {
        icon: 'pi pi-clock',
        severity: 'warn',
        text: 'к выплате 22.09.25',
      },
      date: '22.09.25',
      comments: 'Требуется подтверждение сотрудника',
    },
    {
      id: '3',
      employees: 'Сидоров С.С.',
      sum: 42000,
      payout: {
        icon: 'pi pi-info-circle',
        severity: 'info',
        text: 'к выплате 22.09.25',
      },
      date: '22.09.25',
      comments: 'Возврат средств по заявлению',
    },
    {
      id: '4',
      employees: 'Кузнецов К.К.',
      sum: 99000,
      payout: {
        icon: 'pi pi-times-circle',
        severity: 'danger',
        text: 'к выплате 22.09.25',
      },
      date: '22.09.25',
      comments: 'Отмена заявки до подтверждения',
    },
    {
      id: '5',
      employees: 'Сковорода Л.И.',
      sum: 125000,
      payout: {
      },
      date: '22.09.25',
      comments: 'выплата не произведена',
    },
  ];

  iconTextColumns: PaTableColumn[] = [
    {
      field: 'employees',
      header: 'Сотрудники',
      width: '240px',
      type: PaTableColumnType.Text,
      visibleOnMobile: true,
      icon: 'pi pi-user',
    },
    { 
      field: 'sum', 
      header: 'Сумма', 
      width: '140px', 
      type: PaTableColumnType.Number, 
      visibleOnMobile: true, 
      icon: 'pi pi-money-bill' 
    },
    {
      field: 'payout',
      header: 'Выплата',
      width: '140px',
      type: PaTableColumnType.IconText,
      visibleOnMobile: true,
      icon: 'pi pi-wallet',
    },
    { 
      field: 'date', 
      header: 'Дата', 
      width: '140px', 
      visibleOnMobile: true, 
      icon: 'pi pi-calendar' 
    },
    { 
      field: 'comments', 
      header: 'Комментарии', 
      width: '320px', 
      visibleOnMobile: true, 
      icon: 'pi pi-comment' 
    },
  ];
}
